export const FieldError = ({ msg, id }) =>
  msg ? (
    <p id={`${id}-error`} data-testid={`${id}-error`} role="alert" className="text-xs text-red-700 mt-1.5">
      {msg}
    </p>
  ) : null;
